const LiveActivitiesSports = Object.freeze(['nfl', 'mlb'])

export { LiveActivitiesSports }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/sportradar/enum/LiveActivitiesSportsEnum.js